import { z } from "zod";
import { RESPONSE_STATUS } from "../constnats/general";

// Sort object schema
const sortSchema = z.object({
    sorted: z.boolean(),
    unsorted: z.boolean(),
    empty: z.boolean(),
});

// Pageable object schema
const pageableSchema = z.object({
    sort: sortSchema,
    pageNumber: z.number().int().min(0),
    pageSize: z.number().int().min(1),
    offset: z.number().int().min(0),
    paged: z.boolean(),
    unpaged: z.boolean(),
});

// Main pagination response schema
export const paginationResponseSchema = z.object({
    pageable: pageableSchema,
    last: z.boolean(),
    totalElements: z.number().int().min(0),
    totalPages: z.number().int().min(0),
    sort: sortSchema,
    first: z.boolean(),
    number: z.number().int().min(0),
    numberOfElements: z.number().int().min(0),
    size: z.number().int().min(1),
    empty: z.boolean(),
});

// Type inference
export type PaginationResponseType = z.infer<typeof paginationResponseSchema>;
// type Sort = z.infer<typeof SortSchema>;
// type Pageable = z.infer<typeof PageableSchema>;

const responseStatusSchema = z.nativeEnum(RESPONSE_STATUS);

export const baseResponseSchema = z.object({
    status: responseStatusSchema,
    message: z.string(),
});

export type BaseResponseSchemaType = z.infer<typeof baseResponseSchema>;

export const createResponseSchema = <T extends z.ZodTypeAny>(dataSchema: T) => {
    return baseResponseSchema.extend({
        data: dataSchema,
    });
};

